<template>
  <div>
    <b-modal v-if="!isEmpty(post)" :active.sync="show_edit_post"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head has-background-primary">
          <p class="modal-card-title has-text-white">Ubah Postingan</p>
        </header>
        <section class="modal-card-body is-paddingless">
          <div v-if="!isEmpty(post)">
            <b-tabs v-model="tab" expanded>
              <b-tab-item :label="`Atur ${getPostTypes(post.type)}`">
                <div style="margin-bottom: 20px;">
                  <b-field :label="`Judul ${getPostTypes(post.type)}`">
                    <b-input v-model="post.title" expanded :placeholder="`Judul ${getPostTypes(post.type)}`"></b-input>
                  </b-field>

                  <div class="columns is-vcentered is-mobile" style="margin-bottom: 0;" v-if="['M', 'Q', 'I', 'S', 'E'].indexOf(post.type) > -1">
                    <div class="column">
                      <label class="label">
                        <span>Berkas (Dokumen, Gambar, Video)</span>
                      </label>
                    </div>

                    <div class="column is-narrow">
                      <a class="button is-light is-small" @click.prevent="showMediaLibraryModal(['document', 'image', 'video', 'youtube'])">
                        <span class="icon">
                          <i class="fas fa-paperclip"></i>
                        </span>

                        <span>Tambah Berkas</span>
                      </a>
                    </div>
                  </div>

                  <div class="field" v-if="['M', 'Q', 'I', 'S', 'E'].indexOf(post.type) > -1">
                    <div class="control">
                      <div class="box has-background-white-bis" style="padding: 10px;">
                        <div v-if="!isEmpty(selected_medias)">
                          <div class="columns is-mobile is-vcentered is-gapless" v-for="(media, index) in selected_medias" :key="index" style="margin-bottom: 0;">
                            <div class="column truncated-text">
                              <div class="columns is-mobile is-vcentered is-gapless">
                                <div class="column is-narrow" style="margin-right: 10px;">
                                  <icon-collection :media="media" size="is-16x16"></icon-collection>
                                </div>
                                <div class="column">
                                  <span><small>{{ media.name }}</small></span>
                                </div>
                              </div>
                            </div>
                            <div class="column is-narrow">
                              <a class="button is-text has-text-danger" @click.prevent="deleteMedia([media.id])">
                                <i class="fas fa-trash"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <p v-else class="has-text-grey">Tidak ada berkas.</p>
                      </div>
                    </div>
                  </div>

                  <!-- Quiz Questions -->
                  <b-field label="Pertanyaan" v-if="post.type == 'Z'">
                    <quiz-questions-creator :quiz="post.quiz" :onSaveQuestion="onQuizQuestionAdded"></quiz-questions-creator>
                  </b-field>

                  <!-- Survei -->
                  <b-field label="Tipe" v-if="post.type == 'S'">
                    <div class="block">
                      <b-radio v-model="post.survey.survey_type" native-value="S">Satu Pilihan</b-radio>
                      <b-radio v-model="post.survey.survey_type" native-value="M">Banyak Pilihan</b-radio>
                    </div>
                  </b-field>

                  <b-field label="Opsi" v-if="post.type == 'S'">
                    <survey-creator :onChangeChoices="onChangeSurveyChoices" :choicesData="post.survey.choices"></survey-creator>
                  </b-field>

                  <!-- Event -->
                  <b-field label="Acara" v-if="post.type == 'E'">
                    <event-creator :onChangeEvent="onChangeEvent" :started_data="post.event.start_at" :end_at_data="post.event.end_at" :location_data="post.event.location"></event-creator>
                  </b-field>
                </div>
              </b-tab-item>

              <b-tab-item :label="`Bagikan ${getPostTypes(post.type)}`">
                <b-field label="Catatan">
                  <txteditor :editText="true" :text="post.description" :onUpdate="(text) => post['description'] = text" :toolbars="text_editor_toolbars" v-if="!is_load_description"></txteditor>
                </b-field>

                <!-- Assigment Deadline -->
                <div class="columns is-vcentered" v-if="post.type == 'Q'">
                  <div class="column is-6">
                    <div class="field">
                      <label class="label">
                        <span>Tambahkan Batas Waktu Penyerahan?</span>
                      </label>
                      <div class="control">
                        <b-switch v-model="teacher_question_due_date">{{ teacher_question_due_date ? 'Ya' : 'Tidak' }}</b-switch>
                      </div>
                    </div>
                  </div>
                  <div class="column is-6" v-if="teacher_question_due_date">
                    <div class="field">
                      <label class="label">
                        <span>Pilih Batas Tanggal & Waktu</span>
                      </label>
                      <div class="control">
                        <datetime-picker :datetime="post.teacher_question.due_date" :onChange="(datetime) => post['teacher_question']['due_date'] = datetime"></datetime-picker>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Quiz Deadline -->
                <div class="columns is-vcentered" v-if="post.type == 'Z'">
                  <div class="column is-6">
                    <div class="field">
                      <label class="label">
                        <span>Tambahkan Batas Waktu Penyerahan?</span>
                      </label>
                      <div class="control">
                        <b-switch v-model="quiz_finished_at">{{ quiz_finished_at ? 'Ya' : 'Tidak' }}</b-switch>
                      </div>
                    </div>
                  </div>
                  <div class="column is-6" v-if="quiz_finished_at">
                    <div class="field">
                      <label class="label">
                        <span>Pilih Batas Tanggal & Waktu</span>
                      </label>
                      <div class="control">
                        <datetime-picker :datetime="post.quiz.finished_at" :onChange="(datetime) => post['quiz']['finished_at'] = datetime"></datetime-picker>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="columns is-vcentered">
                  <div class="column is-6">
                    <div class="field">
                      <label class="label">
                        <span>Kapan {{ getPostTypes(post.type) }} akan dibagikan?</span>
                      </label>
                      <div class="control">
                        <div>
                          <div class="columns is-gapless">
                            <div class="column">
                              <b-field>
                                <b-radio-button
                                  v-model="post.status"
                                  native-value="A"
                                  type="is-info"
                                >
                                  <span class="icon"><i class="fa fa-check"></i></span>
                                  <span>Sekarang</span>
                                </b-radio-button>
                                <b-radio-button
                                  v-model="post.status"
                                  native-value="D"
                                  type="is-light"
                                  style="margin-left: 7px;"
                                >
                                  <span class="icon"><i class="fas fa-clock has-text-info"></i></span>
                                  <span class="has-text-info">Nanti</span>
                                </b-radio-button>
                              </b-field>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="column is-6" v-if="post.status == 'D'">
                    <div class="field">
                      <label class="label">
                        <span>Jadwalkan, Pilih Tanggal & Waktu</span>
                      </label>
                      <div class="control">
                        <datetime-picker :datetime="post.published_at" :onChange="(datetime) => post['published_at'] = datetime"></datetime-picker>
                        <p class="help">{{getPostTypes(post.type)}} telah dibagikan, jika Anda mengubah tanggal / waktu, maka akan dibagikan sesuai tanggal & waktu.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab-item>
            </b-tabs>
          </div>
        </section>

        <footer class="modal-card-foot">
          <button type="button" class="button is-fullwidth" @click.prevent="resetData" :disabled="loading_share" :class="{'is-loading': loading_share}">Batal</button>
          <button type="button" v-if="tab == 0" @click.prevent="tab += 1" class="button is-fullwidth is-primary" :disabled="loading_share" :class="{'is-loading': loading_share}">
            <span>Berikutnya</span>
            <span class="icon">
              <i class="fas fa-chevron-right"></i>
            </span>
          </button>
          <button type="button" v-if="tab > 0 && post.status == 'D'" @click.prevent="share" class="button is-fullwidth is-info" :disabled="loading_share" :class="{'is-loading': loading_share}">
            <span class="icon">
              <i class="fas fa-clock"></i>
            </span>
            <span>Bagikan Nanti</span>
          </button>
          <button type="button" v-if="tab > 0 && post.status == 'A'" @click.prevent="share" class="button is-fullwidth is-info" :disabled="loading_share" :class="{'is-loading': loading_share}">
            <span class="icon">
              <i class="fas fa-check"></i>
            </span>
            <span>Bagikan Sekarang</span>
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal
      :active.sync="show_media_library_modal"
      v-if="!isEmpty(post) && ['M', 'Q', 'I', 'S', 'E'].indexOf(post.type) > -1"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal>
      <form action="">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head has-background-primary">
            <p class="modal-card-title has-text-white">Media Library</p>
          </header>
          <section class="modal-card-body">
            <media-library
              :selected_ids="selected_media_ids"
              :multiple="true"
              :types="media_types"
              :mediaCatcher="mediaCatcher"
              :max="5"
              :onClickCancel="() => show_media_library_modal = false"
            ></media-library>
          </section>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { POST } from '~/consts'
import MEDIA_MIXIN from '~/mixins/medias';
import CLASS_MIXIN from '~/mixins/classes';
import SECTION_MIXIN from '~/mixins/sections';
import QuizQuestionsCreator from '~/components/molecules/QuizQuestionsCreator'
import SurveyCreator from '~/components/molecules/SurveyCreator'
import EventCreator from '~/components/molecules/EventCreator'
import TextEditor from '~/components/TextEditor';
import DatetimePicker from '~/components/DateTimePicker';

export default {
  mixins: [MEDIA_MIXIN, CLASS_MIXIN, SECTION_MIXIN],

  components: {
    QuizQuestionsCreator,
    SurveyCreator,
    EventCreator,
    'txteditor': TextEditor,
    DatetimePicker
  },

  props: {
    postData: {
      type: Object,
      required: true
    },
    onSharePostSuccess: {
      type: Function,
      default: () => {}
    },
    onSharePostFailed: {
      type: Function,
      default: () => {}
    },
  },

  computed: {
    selected_media_ids() {
      return collect(this.selected_medias).pluck('id').toArray()
    },
    teacher_question_due_date: {
      get() {
        return this.isEmpty(this.post.teacher_question.due_date) ? false : true
      },
      set(val) {
        this.setTeacherQuestionFinishedAt();
      }
    },
    quiz_finished_at: {
      get() {
        return this.isEmpty(this.post.quiz.finished_at) ? false : true
      },
      set(val) {
        this.setQuizFinishedAt();
      }
    },
    post_status() {
      if (this.isEmpty(this.post)) {
        return 'A'
      }

      return this.post.status
    },
    show_edit_post: {
      get() {
        return !this.isEmpty(this.post) ? true : false
      },
      set() {
        this.post = null
      }
    }
  },

  watch: {
    postData(val) {
      this.post = _.cloneDeep(val)
      this.selected_medias = _.cloneDeep(val.medias)
    },
    post_status(val) {
      if (!this.isEmpty(this.post)) {
        if (val == 'D') {
          this.post['published_at'] = moment().add(1, 'hour').format('YYYY-MM-DD HH:mm:ss')
        } else if (val == 'A') {
          this.post['published_at'] = null
        }
      }
    },
    tab(val) {
      if (val == 1) {
        this.seeMore()
      }
    }
  },

  data() {
    return {
      loading_share: false,
      text_editor_toolbars: ['bold', 'italic', 'strike', 'underline', 'code', 'paragraph', 'heading1', 'heading2', 'heading3', 'paragraph_left', 'paragraph_center', 'paragraph_right', 'paragraph_justify', 'bullet_list', 'ordered_list', 'undo', 'redo'],
      media_types: ['document', 'image', 'youtube'],
      hover_post_type: null,
      hover_media: null,
      tab: 0,
      post: _.cloneDeep(this.postData),
      selected_medias: _.cloneDeep(this.postData.medias),
      is_load_description: false
    }
  },

  methods: {
    showMediaLibraryModal(types) {
      this.media_types = types;

      Vue.nextTick(() => {
        this.show_media_library_modal = true
      })
    },
    mediaCatcher(medias) {
      const vm = this;
      let ref = vm.media_types

      this.selected_medias = _.cloneDeep(medias)

      let media_ids = [];
      medias = collect(medias).whereIn('type', ref);

      if (medias.isNotEmpty()) {
        media_ids = medias.pluck('id').toArray();
      }

      this.show_media_library_modal = false
    },
    setQuizFinishedAt() {
      if (this.post.type == 'Z') {
        if (!this.isEmpty(this.post.quiz.finished_at)) {
          this.post.quiz.finished_at = null;
        } else {
          this.post.quiz.finished_at = moment().add(1, 'hour').format('YYYY-MM-DD HH:mm:ss');
        }
      }
    },
    setTeacherQuestionFinishedAt() {
      if (this.post.type == 'Q') {
        if (!this.isEmpty(this.post.teacher_question.due_date)) {
          this.post.teacher_question.due_date = null;
        } else {
          this.post.teacher_question.due_date = moment().add(1, 'hour').format('YYYY-MM-DD HH:mm:ss');
        }
      }
    },
    deleteMedia(media_ids) {
      const vm = this;

      this.selected_medias = collect(this.selected_medias).filter((m) => {
        return media_ids.indexOf(m.id) <= -1
      }).toArray()
    },
    scrollToBox() {
      let top_position = this.$refs.newpostbox.offsetTop;

      window.scrollTo(0, top_position);
    },
    share() {
      const vm = this

      if (vm.loading_share) {
        return;
      }

      vm.loading_share = true

      let postdata = this.getPostData();

      this.$axios.post(POST.UPDATE_NEW(this.post.id), postdata)
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.onSharePostSuccess();

            this.resetData()
            vm.$buefy.toast.open({
              message: data.applicationSystem.message,
            })
          } else {
            vm.onSharePostFailed();

            vm.$buefy.toast.open({
              message: data.applicationSystem.message,
              type: 'is-danger'
            })
          }
          vm.loading_share = false
        }).catch(() => {
          vm.onSharePostFailed();

          vm.loading_share = false
        })
    },
    onQuizQuestionAdded(questions) {
      this.post.quiz['questions'] = questions
    },
    getPostData() {
      const vm = this
      let postdata = Object.assign({}, this.post, {
        media_ids: this.selected_media_ids,
      })

      if (this.post.type == 'E') {
        postdata.event['started'] = moment(postdata.event['started']).format('YYYY-MM-DD HH:mm:ss')
        if (!this.isEmpty(postdata.event['end_at'])) {
          postdata.event['end_at'] = moment(postdata.event['end_at']).format('YYYY-MM-DD HH:mm:ss')
        }
      }

      return postdata
    },
    resetData() {
      this.loading_share = false
      this.hover_post_type = null
      this.hover_media = null
      this.tab = 0
      this.post = null
      this.selected_medias = []
    },
    onChangeSurveyChoices(choices) {
      this.post.survey['choices'] = choices
    },
    onChangeEvent(event) {
      this.post['event'] = event
    },
    seeMore() {
      this.is_load_description = true
      this.$axios.post(POST.GET_DESCRIPTION(this.post.id))
      .then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          this.post['description'] = data.data.description
        }
        this.is_load_description = false
      })
    }
  }
}
</script>
